export interface ITagReferentiel {
    id_tag_referentiel: number
    id_professionnel: number | null
    id_tag_specific_action: number
    id_category: number
    label: string
    description: string
    color: string
    icon: string
}

export const EmptyTagReferentiel: ITagReferentiel = {
    id_tag_referentiel: 0,
    description: '',
    id_category: 0,
    id_professionnel: null,
    id_tag_specific_action: 0,
    label: '',
    color: '#cccccc',
    icon: 'tag-outline',
}
